import React, { useCallback, useEffect, useState } from 'react';

import {
  Box,
  Button,
  Grid,
  Link,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';

import WhatsappSrc from '../../../../../../assets/img/whatsapp.svg';
// import WhatsappSrc from '../../../../../../assets/img/whatsapp.png';
import Dropzone from '../../../../../../components/Dropzone/Dropzone.component';
import SharedDialog from '../../../../../../components/SharedDialog/SharedDialog.component';
import { appConfig } from '../../../../../../config/app';
import { useSinisterInspectionsContext } from '../../../../../../context/SinisterInspections/SinisterInspections.provider';
import { useIncidentsContext } from '../../../../../../context/incidents/incidents.provider';

const InsideInspectionElement = ({ onAction }: any) => (
  <>
    {/* <img
      src={require(`../../../../../../assets/img/budget.svg`)}
      alt="budget_front"
    /> */}
    <Box my={3}>
      <Button variant="contained" color="primary" onClick={onAction}>
        Foto del dorso de presupuesto
      </Button>
    </Box>
  </>
);

const Step6 = () => {
  // const {
  //   success,
  //   errors,
  //   nextStep,
  //   sinister_body,
  //   image_preview,
  //   updloadPhotos,
  // } = useSinisterDataContext();

  const {
    success,
    errors,
    // step,
    // goBack,
    nextStep,
    // updateSinisterInspectionBody,
    // sinister_inspection_body,
    updloadPhotos,
    image_preview,
    cleanSuccess,
  } = useSinisterInspectionsContext();

  const { incident } = useIncidentsContext();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  const [open, setOpen] = useState(false);
  const [image, setImage] = useState('');
  const [preview, setPreview] = useState(
    image_preview.find((prev: any) => prev.side === 'budget_back')
  );

  const handleNext = (skipped: boolean = false) => {
    if (!skipped && !preview?.['photo[1]']) {
      updloadPhotos(
        {
          side: 'budget_back',
          'photo[1]': image,
          // photo: image,
        },
        incident.id
      );
    } else {
      nextStep();
    }
  };

  const continueToNext = () => {
    setPreview(image_preview.find((prev: any) => prev.side === 'budget_back'));
    nextStep();
    cleanSuccess();
  };

  useEffect(() => {
    if (success?.photo?.side === 'budget_back') {
      continueToNext();
    }
  }, [success, continueToNext, success.photo]);

  useEffect(() => {
    if (errors.photo) {
      setOpen(true);
    }
  }, [errors]);

  return (
    <>
      <SharedDialog
        open={open}
        onClose={() => setOpen(false)}
        content={
          <Box>
            <Box mb={2}>
              <Typography variant="h6">
                ¡Lo sentimos! no pudimos procesar correctamente tus fotos
              </Typography>
              <Typography variant="body2">
                Podés reintentar en unos instantes o comunicarte con nosotros
                por Whatsapp para cargar tu denuncia
              </Typography>
            </Box>
          </Box>
        }
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12} sm={6}>
              <Box m={2} display="flex" alignItems="center">
                <Link
                  href={appConfig?.WHATSAPP_LINK}
                  rel="noopener"
                  target="_blank"
                >
                  <Button variant="outlined" fullWidth color="secondary">
                    <img
                      src={WhatsappSrc}
                      alt="Whatsapp"
                      style={{ marginLeft: '15px' }}
                    />
                    <Typography display="inline">
                      Comunicarme vía Whatsapp
                    </Typography>
                  </Button>
                </Link>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => setOpen(false)}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>
      <Grid container>
        <Grid item xs={12}>
          <Box my={2}>
            <Typography variant="h6">
              Ahora subi foto del dorso de tu presupuesto
            </Typography>
          </Box>
          <Box mb={3}>
            {!matches && (
              <Typography variant="body1">
                Que no esté borrosa, cortada, y ni oscura.
              </Typography>
            )}
          </Box>
        </Grid>
        <Grid item xs={12} md={12}>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={12}>
              <Box m={2}>
                <Dropzone
                  onChange={(file: string) => setImage(file)}
                  onNext={() => handleNext()}
                  preview={preview?.['photo[1]']}
                  optional
                  getFile
                >
                  <InsideInspectionElement />
                </Dropzone>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Step6;
